/** Perfis alinhados a `projeto/js/core/Auth.js` e `accounts.Usuario.perfil`. */
export const PERFIS = ['admin', 'rh', 'gestor', 'analista', 'colab', 'juridico'] as const
export type Perfil = (typeof PERFIS)[number]

export const PERMS = ['edit', 'view', 'own', 'responder'] as const
export type Permissao = (typeof PERMS)[number] | false

export type MatrixRow = Record<string, Permissao>

export type PerfilMeta = {
  label: string
  cor: string
}
